export default "__VITE_ASSET__CbByM1ZZ__"